/* Hypnotic Villas Premium — правила за резервация на ниво тема.
   Минимален престой: 2 нощувки. Прилага се преди заявката към букинг системата
   (/api/quote и /api/book), така че панелът показва ясно съобщение вместо цена за 1 нощувка.
   Настройка: window.HV_MIN_NIGHTS (по подразбиране 2). */
(function () {
  var MIN = parseInt(window.HV_MIN_NIGHTS, 10) || 2;
  var isBg = (document.documentElement.lang || 'bg').toLowerCase().indexOf('bg') === 0;
  var msg = isBg
    ? 'Минималният престой е ' + MIN + ' нощувки. Моля, изберете по-късна дата на напускане.'
    : 'Minimum stay is ' + MIN + ' nights. Please choose a later check-out date.';
  var origFetch = window.fetch;
  if (!origFetch) return;

  function nights(a, b) {
    var d1 = new Date(a + 'T00:00:00Z'), d2 = new Date(b + 'T00:00:00Z');
    return Math.round((d2 - d1) / 86400000);
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/api\/(quote|book)(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var p = JSON.parse(init.body);
        if (p && p.checkin && p.checkout && nights(p.checkin, p.checkout) < MIN) {
          return Promise.resolve(new Response(JSON.stringify({ error: msg }), {
            status: 200, headers: { 'Content-Type': 'application/json' }
          }));
        }
      }
    } catch (e) { /* при съмнение — пускаме заявката */ }
    return origFetch.apply(this, arguments);
  };

  /* Визуален знак: след избор на дата на настаняване, дните под минимума стават неактивни. */
  function markDays() {
    var root = document.getElementById('hv-booking');
    if (!root) return;
    var sel = root.querySelectorAll('.hv-day.hv-sel');
    if (sel.length !== 1) return; // само при избрано настаняване без напускане
    var ci = sel[0].dataset.date;
    root.querySelectorAll('.hv-day[data-date]').forEach(function (b) {
      var ds = b.dataset.date;
      if (ds > ci && nights(ci, ds) < MIN && !b.disabled) {
        b.disabled = true; b.classList.add('hv-min-block'); b.title = msg;
      }
    });
  }
  var box = document.getElementById('hv-months');
  if (box && window.MutationObserver) {
    new MutationObserver(function () { markDays(); }).observe(box, { childList: true, subtree: true });
    markDays();
  }
})();
